import CXMApiClient from "../CXMApiClient";
import { csv } from "../../lib/utilities/HelperFunctions";
import { SpecialLeadStatusIds } from "@/lib/utilities/enums.js";

function initialLoad() {
  return {
    LeadsDashboardFilters: [],
    LeadsDashboardCounts: [],
    LeadsDashboardResults: [],
    AdvancedLeadsDashboardFilters: {
      selectedStatusTypes: [SpecialLeadStatusIds.Active]
    },
    LeadsDashboardPagination: {
      pageTotal: 0,
      pageNumber: 1,
      pageSize: 25,
      totalRecords: 0
    },
    LD_CountsLoading: false,
    LD_ResultsLoading: false,
    LeadSettings: [],
    LeadSettingsLoaded: false,
    SourcesForLeadsDashboard: [],
    ExportInProgress: false
  };
}

const state = initialLoad();

const actions = {
  getLeadSettings: function(context) {
    let platforms = {
      accountPlatformIds: context.getters.ILMStores.map(
        x => x.AccountPlatformID
      )
    };

    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("POST", "/api/CrmLead/leadsettings/get", platforms)
        .then(data => {
          if (data && data.data)
            context.commit("updateLeadSettings", data.data.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  fetchLeadDashboardCounts: function(context, request) {
    context.commit("toggleLoadingIndicatorForCounts", true);
    return new Promise((resolve, reject) => {
      // request.leadStatusIds = [];
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/CrmLead/dashboard/count", request)
        .then(response => {
          context.commit(
            "updateLeadsDashboardCounts",
            response.data && response.data.data ? response.data.data : null
          );
          context.commit("toggleLoadingIndicatorForCounts", false);
          if (response.data && response.data.successful) resolve(response);
          else reject(response);
        })
        .catch(function(error) {
          context.commit("toggleLoadingIndicatorForCounts", false);
          reject(error);
        });
    });
  },
  fetchLeadDashboardResults: function(context, request) {
    context.commit("toggleLoadingIndicatorForSearch", true);
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/CrmLead/dashboard/search", request)
        .then(response => {
          context.commit(
            "updateLeadsDashboardResults",
            response.data && response.data.data ? response.data.data : []
          );
          context.commit("toggleLoadingIndicatorForSearch", false);

          if (response.data && response.data.successful) resolve(response.data);
          else reject(response);
        })
        .catch(function(error) {
          context.commit("toggleLoadingIndicatorForSearch", false);
          reject(error);
        });
    });
  },
  async fetchLeadsDashboardResultsForBulkEmail(context, request) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/CrmLead/dashboard/search",
      request
    );
    return response ? response.data : null;
  },
  async fetchSaleLeads(context, request) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "api/crmLead/sale/counts",
      request.filter,
      request.scope
    );
    return response ? response.data : null;
  },
  updateLeadsDashboardCounts: function(context, data) {
    context.commit("updateLeadsDashboardCounts", data);
  },
  updateLeadsDashboardResults: function(context, data) {
    context.commit("updateLeadsDashboardResults", data);
  },
  updateLeadsDashboardPagination: function(context, data) {
    context.commit("updateLeadsDashboardPagination", data);
  },
  toggleLoadingIndicatorForCounts: function(context, data) {
    context.commit("toggleLoadingIndicatorForCounts", data);
  },
  toggleLoadingIndicatorForSearch: function(context, data) {
    context.commit("toggleLoadingIndicatorForSearch", data);
  },
  updateLeadsDashboardFilters: function(context, request) {
    context.commit("updateLeadsDashboardFilters", request);
  },
  updateAdvancedLeadsDashboardFilters: function(context, request) {
    context.commit("updateAdvancedLeadsDashboardFilters", request);
  },
  updateSourcesForLeadsDashboard: function(context, data) {
    context.commit("updateSourcesForLeadsDashboard", data);
  },
  getInternetLeadsAverageResponseTime: function(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/CrmLead/leadstats/lead_average_response_time",
          request
        )
        .then(response => {
          resolve(response && response.data ? response.data.data : null);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getLeadsDashboardExportResults: function(context, request) {
    context.commit("updateExportLoadingStatus", true);
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("POST", "/api/CrmLead/dashboard/export", request)
        .then(response => {
          context.commit("updateExportLoadingStatus", false);
          if (response && response.data && response.status == 200) {
            let replaceFalse = response.data.replaceAll("False", "No");
            let replaceTrue = replaceFalse.replaceAll("True", "Yes");
            response.data = replaceTrue;
            resolve(csv.processCSV(response));
          } else reject(response);
        })
        .catch(function(error) {
          context.commit("updateExportLoadingStatus", false);
          reject(error);
        });
    });
  },
  async getBulkLeadAssignmentCounts(context, request){
    let response = await new CXMApiClient().ProcessRequest("PUT", "/api/contacts/bulk/assignments/count", request);
    return response && response.data ? response.data.data : null;
  },
  async reassignBulkLeads(context, payload){
    let response = await new CXMApiClient().ProcessRequest("PUT", "/api/contacts/bulk/assignments", payload);
    return response && response.data ? response.data.successful : false;
  }
};

const mutations = {
  updateLeadsDashboardCounts: function(state, data) {
    state.LeadsDashboardCounts = data;
  },
  updateLeadsDashboardResults: function(state, data) {
    state.LeadsDashboardResults = data;
  },
  toggleLoadingIndicatorForCounts: function(state, data) {
    state.LD_CountsLoading = data;
  },
  toggleLoadingIndicatorForSearch: function(state, data) {
    state.LD_ResultsLoading = data;
  },
  updateLeadsDashboardFilters: function(state, data) {
    state.LeadsDashboardFilters = data;
  },
  updateAdvancedLeadsDashboardFilters: function(state, data) {
    state.AdvancedLeadsDashboardFilters = data;
  },
  updateLeadSettings: function(state, data) {
    state.LeadSettings = data && data.length > 0 ? data : [];
    state.LeadSettingsLoaded = true;
  },
  updateSourcesForLeadsDashboard: function(state, data) {
    state.SourcesForLeadsDashboard = data;
  },
  updateExportLoadingStatus: function(state, data) {
    state.ExportInProgress = data;
  }
};

const getters = {
  HasLeadSettings: function(state) {
    return state.LeadSettings && state.LeadSettings.length > 0;
  },
  LeadSettingsLoaded: function(state) {
    return state.LeadSettingsLoaded;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/LeadsDashboard.js